module.exports = __webpack_public_path__ + "static/media/addToSlackOutline.77992048.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/AddToSlackButton/addToSlackOutline.svg
 ** module id = 615
 ** module chunks = 0
 **/